import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Allows the route only for users with role "Endkunde".
 * Handwerker land on their cockpit at `/dashboard`; everyone else goes home.
 */
export const endkundeRoleGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser;

  if (user?.rolle === 'Endkunde') return true;
  if (user?.rolle === 'Handwerker') return router.createUrlTree(['/dashboard']);
  return router.createUrlTree(['/']);
};
